import adTagMapper from "utils/adTagMapper"

const useAdTargeting = (article) => {
  const { id: articleId, nsfw, partner, marketingTags: tags, category, subcategory } = article

  const adTags = getAdTags(tags, category, subcategory)
  const btUser = getBtUser()
  const formattedTags =
    adTags
      ?.map((tag) => tag.toLowerCase().replace(/[']/g, "").replace(/\s+/g, "-"))
      .filter(Boolean) || []

  return {
    page: "article",
    pageId: `article-${articleId}`,
    tags: formattedTags,
    ...(partner && { partnerId: partner.id, brandedContent: true }),
    nsfw,
    ...(btUser && { btUser }),
  }
}

const getAdTags = (tags, category, subcategory) => {
  const adTags = tags.map((tag) => adTagMapper(tag) || tag)

  if (category) {
    adTags.push(category.toLowerCase())
  }

  if (subcategory) {
    adTags.push(subcategory.toLowerCase())
  }

  // remove duplicates and filter out empty values
  return [...new Set(adTags)].filter((tag) => tag)
}

const getBtUser = () => {
  const userAgent = typeof window === "undefined" ? null : navigator.userAgent?.toLowerCase() || ""

  const bots = [
    "ahrefsbot",
    "bingbot",
    "duckduckbot",
    "facebot",
    "googlebot",
    "google web preview",
    "google-read-aloud",
    "moatbot",
    "pinterestbot",
    "ruxitsynthetic",
    "semrushbot",
    "slurp",
    "yisouspider",
  ]

  // loop through potential bots to see if it matches the user agent
  return userAgent ? bots.some((bot) => userAgent.includes(bot)) : null
}

export default useAdTargeting
